/* assets/ahm-entrance.js — home: the vehicle finder + the three-tier inventory band (slot "entrance").
   Shopify version of the mockup's js/entrance.js (the hero lives in ahm-hero-wall.js).
   - Options (make, model, body, year, fuel, transmission, drive, showroom) come from the live stock feed.
   - Values are the stock page's slugs and the field names are its param names (q, make, model, body, ymin,
     kmax, fuel, trans, drive, status, loc), so everything chosen survives the hand-off to /collections/all.
   - "Show N cars" counts with the same rules as ahm-stock.js (M.stockCount when present, else a port).
   - Budget never narrows the list: it only travels to the Find me a car request (/pages/find-me-a-car?budget=…).
   - Tiers: published numbers from M.counts(), network numbers from M.networkSummary(); a tier with no
     numbers is hidden, never shown as 0. If the feed fails, the server-rendered numbers stay. */
(function () {
  'use strict';
  if (!window.M) return;
  var M = window.M;

  var FILTERS = ['q', 'make', 'model', 'body', 'ymin', 'kmax', 'fuel', 'trans', 'drive', 'status', 'loc'];
  /* the Find me a car page reads these names (its fromParams) */
  var TO_FIND = { ymin: 'yearFrom', kmax: 'kmMax' };
  var CHIP_FIELDS = ['fuel', 'trans', 'drive'];
  var BUDGET_WORDS = {
    'under-1m': 'under KES 1 million', '1-2m': 'KES 1 to 2 million', '2-4m': 'KES 2 to 4 million', '4-7m': 'KES 4 to 7 million',
    '7-12m': 'KES 7 to 12 million', '12-20m': 'KES 12 to 20 million', '20m-plus': 'over KES 20 million'
  };

  var S = { el: null, ctx: null, disp: {} };

  function slug(s) { return String(s == null ? '' : s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function $(sel) { return S.el.querySelector(sel); }
  function cars() { return (S.ctx && S.ctx.cars) || M.cars || []; }
  function ssrTotal() { return +(S.el && S.el.getAttribute('data-ssr-total')) || 0; }
  /* the feed failed (or has not landed) while the store does have cars: don't claim "0" */
  function feedMissing() { return !cars().length && ssrTotal() > 0; }

  /* ---------------- matching: the same rules as ahm-stock.js ---------------- */
  var SYN = { '4x4': '4wd', 'auto': 'automatic', 'manual': 'manual', 'suv': 'suv', 'van': 'minivan', 'mpv': 'minivan', 'pickup': 'pickup', 'pick-up': 'pickup', 'ev': 'electric' };
  function hay(c) {
    if (c.__enHay) return c.__enHay;
    var bits = [c.title, c.make, c.model, c.ref, M.shortRef(c), c.body, c.fuel, c.trans, c.drive, c.colour, c.loc, c.cond, c.engine,
      c.status === 'in' ? 'here now in stock' : 'arriving on the way', c.drive === '4WD' ? '4x4' : ''];
    M.needsOf(c).forEach(function (k) { var n = M.need(k); if (n) bits.push(n.label); });
    return (c.__enHay = bits.join(' ').toLowerCase());
  }
  function qMatch(c, q) {
    var h = hay(c);
    return q.toLowerCase().split(/\s+/).filter(Boolean).every(function (t) { t = SYN[t] || t; return h.indexOf(t) > -1; });
  }
  function matches(c, o) {
    if (o.status && c.status !== o.status) return false;
    if (o.loc && (c.status !== 'in' || slug(c.loc) !== o.loc)) return false;
    if (o.make && slug(c.make) !== o.make) return false;
    if (o.make && o.model && slug(c.model) !== o.model) return false;
    if (o.ymin && c.year < +o.ymin) return false;
    if (o.kmax && (!M.kmKnown(c) || c.km > +o.kmax)) return false;
    for (var i = 0; i < CHIP_FIELDS.length; i++) { var k = CHIP_FIELDS[i]; if (o[k] && slug(c[k]) !== o[k]) return false; }
    if (o.body && slug(c.body) !== o.body) return false;
    if (o.q && !qMatch(c, o.q)) return false;
    return true;
  }
  function count(o) {
    var p = params(o);
    if (typeof M.stockCount === 'function') { try { return M.stockCount(p); } catch (e) { /* fall through */ } }
    return cars().filter(function (c) { return matches(c, o); }).length;
  }

  /* ---------------- inventory tiers ---------------- */
  function renderTiers(ctx) {
    var band = $('.en-tiers'); if (!band) return;
    var tLive = $('[data-en-tier="live"]'), tNet = $('[data-en-tier="net"]');
    /* 1. on this website */
    if (tLive && !feedMissing()) {
      var c = M.counts(ctx.cars);
      tLive.hidden = !c.total;
      $('[data-en-live-n]').textContent = M.fmt(c.total);
      $('[data-en-live-u]').textContent = c.total === 1 ? 'car published online' : 'cars published online';
      var parts = [], here = [];
      if (c.nairobi) here.push('Nairobi ' + M.fmt(c.nairobi));
      if (c.mombasa) here.push('Mombasa ' + M.fmt(c.mombasa));
      if (c.in) parts.push('Here now' + (here.length ? ': ' + here.join(' · ') : ': ' + M.fmt(c.in)));
      if (c.way) parts.push(M.fmt(c.way) + ' arriving');
      $('[data-en-live-s]').textContent = parts.join(' · ');
    }
    /* 2. the showroom network (shop metafield ahm.network) */
    if (tNet) {
      var n = M.networkSummary();
      if (!n.here && !n.way) { tNet.hidden = true; }
      else {
        tNet.hidden = false;
        $('[data-en-net-k]').textContent = ctx.partnerNote ? 'In partner showrooms' : 'In our showroom network';
        var line = $('[data-en-net-line]');
        var cities = [];
        if (n.nairobi) cities.push('Nairobi');
        if (n.mombasa) cities.push('Mombasa');
        line.innerHTML = n.here
          ? '<span class="t-num" data-en-net-n>' + M.fmt(n.here) + '</span> <span class="en-tier-u">' + (cities.length ? 'in ' + M.esc(cities.join(' & ')) : 'here now') + '</span>' +
            (n.way ? '<span class="en-tier-plus t-num">+ ' + M.fmt(n.way) + ' on the way</span>' : '')
          : '<span class="t-num" data-en-net-n>' + M.fmt(n.way) + '</span> <span class="en-tier-u">on the way</span>';
        var detail = [];
        if (n.nairobi) detail.push('Nairobi ' + M.fmt(n.nairobi));
        if (n.mombasa) detail.push('Mombasa ' + M.fmt(n.mombasa));
        var way = [];
        if (n.inJapan) way.push(M.fmt(n.inJapan) + ' still in Japan');
        if (n.inTransit) way.push(M.fmt(n.inTransit) + ' in transit');
        if (n.atPort) way.push(M.fmt(n.atPort) + ' at port');
        var first = detail.join(' · ') + (way.length ? (detail.length ? ' · ' : '') + 'on the way from Japan: ' + way.join(', ') : '');
        var fine = n.total
          ? (ctx.partnerNote ? 'Partner stock list' : 'Network stock list') + (n.date ? ' of ' + n.date : '') + ': ' + M.fmt(n.total) + ' cars in all' +
            (n.unknown ? ', ' + M.fmt(n.unknown) + ' still awaiting a status' : '') + (M.netMore() ? '. The cars on this website are among them.' : '. Every one of them is on this website.')
          : '';
        $('[data-en-net-s]').innerHTML = (first ? '<span>' + M.esc(first) + '</span>' : '') + (fine ? '<span class="en-tier-fine">' + M.esc(fine) + '</span>' : '');
      }
    }
  }

  /* ---------------- finder ---------------- */
  function form() { return $('[data-en-form]'); }
  function readForm() {
    var f = form(), o = {};
    FILTERS.forEach(function (k) {
      var el = f.elements[k]; if (!el) { o[k] = ''; return; }
      o[k] = String(el.value || '').trim();
    });
    o.q = o.q.slice(0, 80);
    o.budget = f.elements.budget ? f.elements.budget.value : '';
    return o;
  }

  function fillSelect(sel, anyLabel, items, keep) {
    if (!sel) return;
    var cur = keep != null ? keep : sel.value;
    sel.innerHTML = '<option value="">' + M.esc(anyLabel) + '</option>' + items.map(function (it) {
      return '<option value="' + M.esc(it.v) + '">' + M.esc(it.t) + '</option>';
    }).join('');
    sel.value = items.some(function (it) { return it.v === cur; }) ? cur : '';
  }

  function chipsHTML(name, items, cur) {
    var sid = S.el.getAttribute('data-en-uid');
    return items.map(function (it) {
      var id = 'en-' + sid + '-' + name + '-' + (it.v || 'any');
      return '<label class="en-chip" for="' + id + '"><input type="radio" id="' + id + '" name="' + name + '" value="' + M.esc(it.v) + '"' + (it.v === cur ? ' checked' : '') + '><span>' + M.esc(it.t) + '</span></label>';
    }).join('');
  }

  /* distinct values of a field → [{v: slug, t: label}], sorted by label; also remembers slug → label */
  function values(list, field) {
    var seen = {};
    list.forEach(function (c) { var raw = c[field]; if (raw == null || raw === '') return; var s = slug(raw); if (s && !seen[s]) seen[s] = String(raw); });
    S.disp[field] = seen;
    return Object.keys(seen).sort(function (a, b) { return seen[a].localeCompare(seen[b]); }).map(function (k) { return { v: k, t: seen[k] }; });
  }

  function buildOptions(ctx) {
    var list = ctx.cars;
    var o = readForm();
    /* make: data-driven with counts (M.makes is sorted by count) */
    var mk = M.makes(list);
    S.disp.make = {};
    fillSelect($('[data-en-make]'), 'Any make', mk.map(function (m) { S.disp.make[slug(m.make)] = m.make; return { v: slug(m.make), t: m.make + ' (' + M.fmt(m.count) + ')' }; }), o.make);
    fillSelect($('[data-en-body]'), 'Any body', values(list, 'body'), o.body);
    var ys = {};
    list.forEach(function (c) { var y = parseInt(c.year, 10); if (y > 1900) ys[y] = 1; });
    fillSelect($('[data-en-year]'), 'Any year', Object.keys(ys).sort().reverse().map(function (y) { return { v: y, t: y + ' or newer' }; }), o.ymin);

    var sets = {};
    CHIP_FIELDS.forEach(function (k) { sets[k] = values(list, k); });
    /* availability: only the states that exist; showroom: only cities with cars here now */
    var hasIn = list.some(function (c) { return c.status === 'in'; }), hasWay = list.some(function (c) { return c.status === 'way'; });
    sets.status = [];
    if (hasIn) sets.status.push({ v: 'in', t: 'Here now' });
    if (hasWay) sets.status.push({ v: 'way', t: 'Arriving' });
    sets.loc = values(list.filter(function (c) { return c.status === 'in'; }), 'loc');
    Object.keys(sets).forEach(function (k) {
      var items = sets[k], box = $('[data-en-chips="' + k + '"]'), fs = $('[data-en-set="' + k + '"]');
      if (!box) return;
      /* one value only = nothing to choose: hide the group (never a broken empty box) */
      if (fs) fs.hidden = items.length < 2;
      var anyLabel = k === 'loc' ? (items.length === 2 ? 'Both showrooms' : 'Any showroom') : 'Any';
      var all = [{ v: '', t: anyLabel }].concat(items);
      var cur = o[k]; if (!all.some(function (it) { return it.v === cur; })) cur = '';
      box.innerHTML = chipsHTML(k, all, cur);
    });
    buildModels(list, o.model);
  }

  function buildModels(list, keep) {
    var f = form(), make = f.elements.make.value, sel = $('[data-en-model]');
    if (!sel) return;
    if (!make) { sel.innerHTML = '<option value="">Choose a make first</option>'; sel.value = ''; sel.disabled = true; return; }
    var models = {}, label = {};
    list.forEach(function (c) { if (slug(c.make) === make && c.model) { var s = slug(c.model); models[s] = (models[s] || 0) + 1; label[s] = c.model; } });
    S.disp.model = label;
    fillSelect(sel, 'Any model', Object.keys(models).sort(function (a, b) { return label[a].localeCompare(label[b]); }).map(function (m) { return { v: m, t: label[m] + ' (' + M.fmt(models[m]) + ')' }; }), keep);
    sel.disabled = false;
  }

  /* stock page params: the field names already are the stock page's */
  function params(o) {
    var p = {};
    FILTERS.forEach(function (k) { if (o[k]) p[k] = o[k]; });
    return p;
  }
  /* Find me a car params: readable labels, its own names for year/mileage, and the budget */
  function findUrl(o) {
    var p = {};
    FILTERS.forEach(function (k) {
      if (!o[k]) return;
      var v = o[k];
      var d = S.disp[k]; if (d && d[v]) v = d[v];
      p[TO_FIND[k] || k] = v;
    });
    if (o.budget) p.budget = o.budget;
    var q = Object.keys(p).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(p[k]); }).join('&');
    return M.urls.find + (q ? '?' + q : '');
  }

  function update() {
    var o = readForm();
    var missing = feedMissing();
    var n = missing ? -1 : count(o);
    var active = FILTERS.filter(function (k) { return k !== 'q' && k !== 'make' && o[k]; }).length + (o.budget ? 1 : 0);
    var badge = $('[data-en-active]');
    if (badge) { badge.hidden = !active; badge.textContent = active; }
    var more = $('[data-en-more]');
    if (more) more.setAttribute('aria-label', 'More filters' + (active ? ', ' + active + ' set' : ''));

    var any = FILTERS.some(function (k) { return o[k]; });
    var show = $('[data-en-show]');
    if (show) {
      if (n < 0) { show.textContent = 'Show cars'; show.removeAttribute('aria-disabled'); }
      else if (n === 0) { show.textContent = 'No matches online'; show.setAttribute('aria-disabled', 'true'); }
      else { show.textContent = (any ? 'Show ' + M.fmt(n) + ' ' : 'Show all ' + M.fmt(n) + ' ') + (n === 1 ? 'car' : 'cars'); show.removeAttribute('aria-disabled'); }
    }
    /* secondary action: honest about budget */
    var alt = $('[data-en-alt]');
    if (alt) {
      alt.setAttribute('href', findUrl(o));
      alt.textContent = o.budget ? 'Send this budget to the concierge' : (n === 0 ? 'Ask the concierge to source it' : (alt.getAttribute('data-default') || 'Not here? Ask the concierge'));
      alt.classList.toggle('en-alt--budget', !!o.budget);
    }
    var note = $('[data-en-budget-note]');
    if (note) {
      note.classList.toggle('is-set', !!o.budget);
      note.textContent = o.budget
        ? 'Prices are shared on request, so we cannot filter by ' + (BUDGET_WORDS[o.budget] || 'budget') + '. Send it to the concierge and they will shortlist cars in range from this site and the ' + (S.ctx && S.ctx.partnerNote ? 'partner showrooms' : 'showroom network') + '.'
        : 'Prices are shared on request, so budget does not narrow this list. The concierge uses it to shortlist.';
    }
    var clr = $('[data-en-clear]'); if (clr) clr.hidden = !any && !o.budget;

    var live = $('[data-en-live]');
    if (live && n >= 0) live.textContent = n === 0 ? 'No published cars match. You can ask the concierge to source it.' : M.fmt(n) + (n === 1 ? ' car matches.' : ' cars match.');
    return { n: n, o: o };
  }

  function scopeNote(ctx) {
    var el = $('[data-en-scope]'); if (!el || feedMissing()) return;
    var n = ctx.cars.length;
    el.innerHTML = (n
      ? 'Searching the <b class="t-num">' + M.fmt(n) + '</b> ' + (n === 1 ? 'car' : 'cars') + ' published on this website. '
      : 'No cars are published on this website right now. ') +
      '<a class="en-inline" href="' + M.esc(M.urls.find) + '">Ask for any car in the network <span aria-hidden="true">→</span></a>';
  }

  function toggleMore(open) {
    var btn = $('[data-en-more]'), panel = $('[data-en-all]');
    if (open == null) open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
    $('.en-console').classList.toggle('is-open', open);
  }

  function submit() {
    var r = update();
    if (r.n === 0) { M.toast('No published car matches those filters. Ask the concierge to source it.'); return; }
    M.go(M.stockUrl(params(r.o)));
  }

  /* ---------------- binding (once per element; the theme editor can hand us a fresh one) ---------------- */
  var uid = 0;
  function bind(el) {
    if (el.__enBound) return;
    el.__enBound = 1;
    el.setAttribute('data-en-uid', String(++uid));
    var f = el.querySelector('[data-en-form]');
    var alt = el.querySelector('[data-en-alt]'); if (alt) alt.setAttribute('data-default', alt.textContent.trim());
    f.addEventListener('submit', function (e) { S.el = el; e.preventDefault(); submit(); });
    f.addEventListener('change', function (e) { S.el = el; if (e.target.name === 'make') buildModels(cars()); update(); });
    f.addEventListener('input', function (e) { S.el = el; if (e.target.name === 'q') update(); });
    el.querySelector('[data-en-more]').addEventListener('click', function () { S.el = el; toggleMore(); });
    el.querySelector('[data-en-clear]').addEventListener('click', function () {
      S.el = el;
      Array.prototype.forEach.call(f.elements, function (x) {
        if (x.type === 'radio') x.checked = x.value === '';
        else if (x.tagName === 'SELECT' || x.tagName === 'INPUT') x.value = '';
      });
      buildOptions(S.ctx || { cars: cars() }); update();
      var qi = el.querySelector('[data-en-q]'); if (qi) qi.focus();
    });
  }

  M.view('entrance', {
    init: function (el, ctx) { S.el = el; S.ctx = ctx; bind(el); },
    render: function (el, ctx) {
      S.el = el; S.ctx = ctx;
      bind(el);
      renderTiers(ctx);
      scopeNote(ctx);
      buildOptions(ctx);
      update();
    }
  });

  /* bind straight away (the DOM is parsed when this deferred script runs), so the finder works while the
     feed is still loading: until then a search goes to the stock page with whatever was chosen */
  Array.prototype.forEach.call(document.querySelectorAll('[data-slot="entrance"]'), function (el) { if (!S.el) S.el = el; bind(el); });

  /* theme editor: a re-rendered section is new markup the core has not seen */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-slot="entrance"]')) M.rerender();
  });
})();
